import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { AuthType } from "../../../ducks/auth";
import { useAuth } from "../../../hooks/useAuth";
import { RegisterForm } from "../../organisms/form/RegisterForm";
import { useRegistration } from "./hook";

export const Registration: React.FC = () => {
  const { handleAuthValidationError } = useAuth();
  const { type, value, name, email, phoneNumber, handleRegistration } =
    useRegistration();

  return (
    <Container>
      <TitleWrapper>お客さま情報の入力</TitleWrapper>

      <RegisterForm
        type={type}
        name={name}
        email={
          email ? email : type === AuthType.Email.valueOf() ? value : undefined
        }
        phoneNumber={
          phoneNumber
            ? phoneNumber
            : type === AuthType.PhoneNumber.valueOf()
              ? value
              : undefined
        }
        handleAuthValidationError={handleAuthValidationError}
        handleSubmit={handleRegistration}
      />
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px 57px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  padding: 43px 0 38px;
  display: flex;
  line-height: 1;
  font-weight: 500;
  justify-content: center;
  font-family: "Hiragino Sans";
`;
